import { Scanner } from "@yudiel/react-qr-scanner";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Cambiado el nombre de la función a QRScan para consistencia con la importación en el wizard
export default function QRScan({ onScanSuccess }) {
  
  const [qrResult, setQrResult] = useState(null);
  const [isScanning, setIsScanning] = useState(true); // Controla si el escáner está activo

  useEffect(() => {
    // Si hay un resultado válido y todavía estamos escaneando...
    if (qrResult && qrResult.length > 0 && isScanning) {
      
      const scannedValue = qrResult[0].rawValue;
      
      // Validación: Si es un link web, mostramos error y permitimos re-escanear sin cerrar
      if (scannedValue.includes("lisual.com") || scannedValue.includes("camaraSetupWizard") || scannedValue.includes("/")) {
          toast.error("Error: Parece que escaneaste el QR de la WEB. Por favor, escanea el código QR pegado en la cámara.", {
            toastId: "qr-web-error", // Evita duplicados
            autoClose: 4000
          });
          setQrResult(null);
          return;
      }
      
      console.log(`UID Escaneado: ${scannedValue}`);
      
      // 1. Llamar a la función del componente padre con el UID escaneado
      // El componente padre (wizard) recibirá este string y lo usará.
      if (onScanSuccess) {
          onScanSuccess(scannedValue);
      }
      
      // 2. Detener el escaneo y notificar al usuario
      setIsScanning(false); 
      
      toast.success(`✅ Cámara registrada con éxito. UID: ${scannedValue}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [qrResult, onScanSuccess, isScanning]);

  // Manejar el error de la cámara, si es necesario
  const handleError = (error) => {
    console.error("Error al acceder a la cámara:", error);
    // Opcional: Mostrar un toast de error si el problema persiste
  };
    
  // El Scanner sólo se renderiza si isScanning es true
  return (
    
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      
      <div className="w-full max-w-sm md:max-w-md lg:max-w-lg p-6 bg-white shadow-2xl rounded-xl border border-gray-200">
        
        <h2 className="text-2xl font-extrabold text-center text-indigo-600 mb-6">
          {isScanning ? "Escanear Código QR" : "Escaneo Completo"}
        </h2>

        {isScanning && ( // Solo muestra el Scanner si está escaneando
            <div className="rounded-xl overflow-hidden shadow-lg border-4 border-indigo-500/50">
                <Scanner
                    onScan={(result) => setQrResult(result)}
                    onError={handleError}
                    styles={{
                        container: { width: '100%', height: 'auto' },
                        video: {
                            width: '100%',
                            height: 'auto',
                        },
                    }}
                />
            </div>
        )}
        
        {!isScanning && ( // Muestra un mensaje después de escanear
            <p className="p-4 text-center text-lg text-green-600 bg-green-50 rounded-lg border border-green-200">
                Datos de la cámara capturados correctamente.
            </p>
        )}

        <p className="mt-4 text-center text-sm text-gray-500">
          Asegúrate de que el código QR esté bien iluminado y dentro del marco.
        </p>

        </div>

      <ToastContainer />
    </div>

  );
}